var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.event)?_c('docs-manager',{ref:"docsManager",attrs:{"event":_vm.event,"docs":_vm.documents}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }